import React, { useState, useRef, useEffect } from 'react';
import './styles/FilterPanelAuditor.css';
import { lang } from '../../generales/traduction';
import { capitalizeFirstLetter } from '../../../utils/utils';
import SelectorAdmin from '../../SelectorAdmin';
const FilterPanelAuditor = ({
  isOpen,
  languaje,
  server,
  opciones,
  setOpciones,
  range,
  setRange
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: window.innerWidth - 350, y: 80 });
  const offset = useRef({ x: 0, y: 0 });

  const handleClearFilters = () => {
    setOpciones(prev => ({
      ...prev,
      user_email: "",
      module_id: null,
      name_module: "",
      name_action: "",
      fecha_ini: "",
      fecha_fin: ""
    }));
  };

  const handleMouseDown = (e) => {
    if (e.target.closest('button, input, .rs-picker, .options-dropdown div')) {
      return;
    }
    setIsDragging(true);
    const panel = e.currentTarget;
    offset.current.x = e.clientX - panel.offsetLeft;
    offset.current.y = e.clientY - panel.offsetTop;
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    let newX = e.clientX - offset.current.x;
    let newY = e.clientY - offset.current.y;
    if (newX < 0) newX = 0;
    if (newX > window.innerWidth - 320) newX = window.innerWidth - 320;
    if (newY < 0) newY = 0;
    if (newY > window.innerHeight - 80) newY = window.innerHeight - 80;
    setPosition({ x: newX, y: newY });
  }

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const dataModulos = {
    loading: false,
    data: {
      data: [
        { id: "Mediciones", name: "Mediciones" },
        { id: "Eventos", name: "Eventos" },
        { id: "Disparadores", name: "Disparadores" },
        { id: "Correlaciones", name: "Correlaciones" },
        { id: "Excepciones", name: "Excepciones" },
        { id: "Estado de Hosts", name: "Estado de Hosts" }
      ]
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOpciones((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const changeOptionModule = (option) => {
    setOpciones((prevState) => ({
      ...prevState,
      module_id: option.value === 0 ? null : option.value,
      name_module: option.value === 0 ? "" : option.value
    }));
  };

  const changeOptionAction = (option) => {
    setOpciones((prevState) => ({
      ...prevState,
      name_action: option.value === 0 ? "" : option.value
    }));
  };

  const actionsData = {
    data: [
      { id: "Crear", name: "Crear" },
      { id: "Editar", name: "Editar" },
      { id: "Eliminar", name: "Eliminar" }
    ]
  };

  const selectedActionVal = opciones.name_action === "Crear" ? "Crear" :
    opciones.name_action === "Editar" ? "Editar" :
      opciones.name_action === "Eliminar" ? "Eliminar" : 0;

  return (
    <div>
      {isOpen && (
        <div className="filter-panel-premium"
          style={{
            left: `${position.x}px`,
            top: `${position.y}px`,
          }}
          onMouseDown={handleMouseDown}>

          <div className="filter-panel-header">
            <span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
              </svg>
              Filtros Auditor
            </span>
            <button className="filter-panel-clear-btn" onClick={handleClearFilters}>
              Limpíar
            </button>
          </div>

          <div className="filter-panel-body">

            <div className="filter-field-wrapper">
              <label className='filter-field-label'>{(lang[languaje]['fecha'] || 'Rango de Fechas')}</label>
              <div className="date-row">
                <div className="date-col">
                  <span style={{ fontSize: '10px', color: 'var(--txt-color)', opacity: '0.8' }}>Inicio</span>
                  <input
                    className="premium-input"
                    type="datetime-local"
                    name="fecha_ini"
                    value={opciones.fecha_ini}
                    onChange={handleChange}
                  />
                </div>

              </div>
            </div>

            <div className="filter-field-wrapper">
              <div className="date-col">
                <span style={{ fontSize: '10px', color: 'var(--txt-color)', opacity: '0.8' }}>Fin</span>
                <input
                  className="premium-input"
                  type="datetime-local"
                  name="fecha_fin"
                  value={opciones.fecha_fin}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="filter-field-wrapper">
              <label className='filter-field-label'>{capitalizeFirstLetter(lang[languaje]['correo'] || 'Correo')}</label>
              <input className="premium-input" name="user_email" type="text" value={opciones.user_email || ""} onChange={handleChange} placeholder="Buscar por usuario..." />
            </div>

            <div className="filter-field-wrapper">
              <label className='filter-field-label'>{capitalizeFirstLetter(lang[languaje]['modulo'] || 'Módulo')}</label>
              {dataModulos.loading ? (
                <p style={{ color: 'var(--txt-color)', fontSize: '13px' }}>{capitalizeFirstLetter(lang[languaje]['CargandoDatos'] || 'Cargando...')} . . .</p>
              ) : (
                <SelectorAdmin
                  placeholder={'Seleccionar módulo...'}
                  opGeneral={true}
                  txtOpGen={''}
                  opt_de={opciones.name_module || 0}
                  origen={'Admin'}
                  data={dataModulos.data.data}
                  loading={dataModulos.loading}
                  titulo='Modulos'
                  selectFunction={changeOptionModule}
                  index={0}
                />
              )}
            </div>

            <div className="filter-field-wrapper">
              <label className='filter-field-label'>Acción</label>
              <SelectorAdmin
                placeholder={'Seleccionar acción...'}
                opGeneral={true}
                txtOpGen={''}
                opt_de={selectedActionVal}
                origen={'Admin'}
                data={actionsData.data}
                loading={false}
                titulo='trigger'
                selectFunction={changeOptionAction}
                index={0}
              />
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanelAuditor;
